(function () {
  'use strict';

  function initCaseArticle(root) {
    var body = root.querySelector('[data-sd-case-body]');
    var toc = root.querySelector('[data-sd-case-toc]');
    var list = root.querySelector('[data-sd-case-toc-list]');
    if (!body || !toc || !list) return;

    var headings = body.querySelectorAll('h2');
    if (headings.length < 2) return;

    for (var i = 0; i < headings.length; i++) {
      var heading = headings[i];
      if (!heading.id) heading.id = 'case-section-' + (i + 1);

      var item = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + heading.id;
      link.textContent = heading.textContent.trim();
      item.appendChild(link);
      list.appendChild(item);
    }

    toc.hidden = false;
  }

  function init() {
    var roots = document.querySelectorAll('[data-sd-case-article]');
    for (var i = 0; i < roots.length; i++) initCaseArticle(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
